import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { RiskService } from '../../../../services/risk/risk.service';
import { latLng, tileLayer, circleMarker, MapOptions, Layer } from 'leaflet';
import { IAnalyticsState } from 'src/app/state-management/states/aumye-analytics.state';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { IRiskHeatMap } from 'src/app/models/riskProfile';
import { EChartsOption } from 'echarts';
import type { CallbackDataParams } from 'echarts/types/dist/shared';
import { ScreenType } from 'src/app/enums/ScreenType';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';

interface IcategorizedIncidents {
  incidentId: string;
  incidentName: string;
  riskTrendPercentage: number;
}

interface IRiskCategoryTrend {
  name: string;
  incidentsCount: number;
  trend: number;
  trendDirection: 'up' | 'down' | 'neutral';
}

interface IIncident {
  category: string;
  total: number;
  critical: number;
  quickest: string;
  longest: string;
  score: number;
  weakestHour: string;
  strongestOccupancy: string;
  chartData: EChartsOption;
}

// interface IAnalyticsState {
//   categorizedIncidents: any[];
//   processedIncidents: any[];
//   categoryRiskTrends: any[];
//   overallRiskScore: number;
//   overallRiskTrend: string;
//   overallRiskChangePercentage: number;
//   riskHeatMapData: any;
//   totalCount: {
//     categorizedCriticalCount: number;
//     categorizedMediumCount: number;
//     categorizedLowOrNoCount: number;
//   };
// }

@Component({
  selector: 'app-risk-dashboard',
  templateUrl: './risk-dashboard.component.html',
  styleUrls: ['./risk-dashboard.component.scss'],
})
export class RiskDashboardComponent implements OnInit, AfterViewInit {
  totalCount = {
    categorizedCriticalCount: 0,
    categorizedMediumCount: 0,
    categorizedLowOrNoCount: 0,
  };
  OverallRiskScoresByDateRange: any;
  screenSize: ScreenType;
  categorizedRiskScore: any;
  @Input() set analyticsData(val: IAnalyticsState) {
    if (val) {
      this.categorizedIncidents = val.categorizedIncidents;
      this.categorizedRiskScore = val.categorizedRiskScore;
      this.processedIncidents = val.processedIncidents;
      this.categoryRiskTrends = val.categoryRiskTrends;
      this.overallScore = val.overallRiskScore;
      this.overallRiskTrend = val.overallRiskTrend;
      this.overallRiskChangePercentage = val.overallRiskChangePercentage;
      this.riskHeatMapData = val.riskHeatMapData;
      this.totalCount = val.totalCount || {
        categorizedCriticalCount: 0,
        categorizedMediumCount: 0,
        categorizedLowOrNoCount: 0,
      };
      this.OverallRiskScoresByDateRange = val.overallRiskScoresByDateRange;

      // this.totalIncident = this.processedIncidents.length || 0;
      this.totalIncident = Array.isArray(this.processedIncidents)
        ? this.processedIncidents.length
        : 0;

      // this.populateCategoricalBreakdown(this.categorizedIncidents);
      this.updateCategoricalBreakdownFromIncidents(this.categorizedIncidents);
      this.generateRiskTrendChart();
    }

    this.prepareCategories();
    this.updatePerformanceIndicators();
    // this.processIncidentData();
    // this.updateRiskScoreProgress()
    // this.generateIncidentTrendChart();
    this.IncidentTrendsbyCategory = this.generateChartOption(
      this.categorizedIncidents,
      this.selectedRange
    );
  }

  quickestResponseTime: number = Infinity;
  longestResponseTime: number = 0;
  hottestHour: number = 0;
  strongestHour: number = 0;
  weakestHour: number = 0;
  hottestHourIncidentCount: number = 0;

  performanceIndicators = [
    { label: 'Quickest Response', value: '5m' },
    { label: 'Longest Response', value: '0m' },
    { label: 'Hottest Hour', value: '12AM', subtext: '0 incidents' },
    { label: 'Strongest Hour', value: '12AM' },
    { label: 'Weakest Hour', value: '12AM' },
    { label: 'Strongest Occupancy', value: '12AM', subtext: '→ 0%' },
  ];

  totalIncident = 0;
  gridCols = 4;
  catCols = 3;

  // realTimeScore = 78;

  // performanceIndicators = [
  //   { label: 'Response Time (avg)', value: '4.5m' },
  //   { label: 'Critical Incidents', value: 12 },
  //   { label: 'Resolved Today', value: 43 },
  //   { label: 'Escalated', value: 6 }
  // ];

  categoryRiskTrends: any = null;
  overallRiskScore: any = null;
  overallRiskTrend: any = null;
  overallRiskChangePercentage: any = null;
  categorizedIncidents: any = null;
  processedIncidents: any = [];

  riskHeatMapData: IRiskHeatMap[] = [];

  resData = {
    name: 'claim',
    hottestHour: 6,
    strongestHour: 7,
    weakestHour: 8,
    peakHours: [9, 2],
    totalIncidents: 5,
    riskScore: 20,
  };

  CategoricalBreakdown: EChartsOption = {
    xAxis: {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    },
    yAxis: {
      type: 'value',
    },
    series: [
      {
        data: [820, 932, 901, 934, 1290, 1330, 1320],
        type: 'line',
        smooth: true,
      },
    ],
  };

  RiskTrendData: EChartsOption = {
    title: {
      text: 'Risk Trend Over Time',
      left: 'center',
      top: '10',
    },
    tooltip: {
      trigger: 'axis',
    },
    legend: {
      data: ['Risk Score'],
      top: 35,
      left: 'center',
    },
    xAxis: {
      type: 'category',
      data: ['9/1/2023', '9/2/2023', '9/3/2023', '9/4/2023', '9/5/2023'],
      boundaryGap: false,
    },
    yAxis: {
      type: 'value',
      min: 0,
      max: 100,
      axisLabel: {
        formatter: '{value} %',
      },
    },
    series: [
      {
        name: 'Risk Score',
        type: 'line',
        smooth: true,
        data: [40, 60, 30, 70, 50],
        symbol: 'circle',
        symbolSize: 8,
        lineStyle: {
          color: '#f44336',
          width: 3,
        },
        itemStyle: {
          color: '#f44336',
        },
        areaStyle: {
          color: 'rgba(244, 67, 54, 0.2)',
        },
      },
    ],
  };

  IncidentTrendsbyCategory: EChartsOption = {
    title: {
      text: 'Incident Trends by Category',
      left: 'center',
      top: 10,
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params: CallbackDataParams | CallbackDataParams[]) => {
        const items = Array.isArray(params) ? params : [params];
        const total = items.reduce((sum, item) => sum + Number(item.value), 0);
        return items
          .map(
            (item) =>
              `${item.seriesName}: ${item.value} (${(
                (Number(item.value) / total) *
                100
              ).toFixed(1)}%)`
          )
          .join('<br>');
      },
    },
    legend: {
      top: 40,
      data: ['Security', 'Safety', 'Maintenance', 'Environmental'],
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        data: ['12 Nov', '13 Nov', '14 Nov', '15 Nov', '16 Nov'],
      },
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          formatter: '{value} %',
        },
        max: 100,
      },
    ],
    series: [
      {
        name: 'Security',
        type: 'bar',
        stack: 'total',
        emphasis: { focus: 'series' },
        label: { show: false },
        data: [20, 10, 30, 20, 4],
      },
      {
        name: 'Safety',
        type: 'bar',
        stack: 'total',
        emphasis: { focus: 'series' },
        data: [1, 2, 1, 3, 2],
      },
      {
        name: 'Maintenance',
        type: 'bar',
        stack: 'total',
        emphasis: { focus: 'series' },
        data: [0, 1, 2, 1, 0],
      },
      {
        name: 'Environmental',
        type: 'bar',
        stack: 'total',
        emphasis: { focus: 'series' },
        data: [1, 0, 1, 0, 1],
      },
    ],
    toolbox: {
      feature: {
        saveAsImage: {},
      },
    },
  };

  selectedRange: '1d' | '1w' | '1m' | '1y' = '1w';
  onRangeChange(range: '1d' | '1w' | '1m' | '1y') {
    this.selectedRange = range;
    this.IncidentTrendsbyCategory = this.generateChartOption(
      this.categorizedIncidents,
      range
    );
  }

  // generateChartOption(data: any, range: '1d' | '1w' | '1m' | '1y'): EChartsOption {
  //   const categories = Object.keys(data);

  //   // Extract and format all unique dates
  //   const allDatesSet = new Set<string>();
  //   const now = new Date();
  //   let startDate = new Date(now);
  //   const formatDate = (date: Date) =>
  //     date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
  //   const filteredData: Record<string, any[]> = {};

  //   switch (range) {
  //     case '1d': startDate.setDate(now.getDate() - 1); break;
  //     case '1w': startDate.setDate(now.getDate() - 7); break;
  //     case '1m': startDate.setMonth(now.getMonth() - 1); break;
  //     case '1y': startDate.setFullYear(now.getFullYear() - 1); break;
  //   }

  //   // categories.forEach(category => {
  //   //   data[category]?.forEach((incident: any) => {
  //   //     const date = new Date(incident.incidentDate);
  //   //     const formattedDate = date.toLocaleDateString('en-GB', {
  //   //       day: '2-digit',
  //   //       month: 'short',
  //   //     });
  //   //     allDatesSet.add(formattedDate);
  //   //   });
  //   // });

  //   categories.forEach(category => {
  //     const filtered = (data[category] || []).filter((incident: any) => {
  //       const incidentDate = new Date(incident.incidentDate);
  //       return incidentDate >= startDate && incidentDate <= now;
  //     });

  //     filtered.forEach((incident: any) => {
  //       allDatesSet.add(formatDate(new Date(incident.incidentDate)));
  //     });

  //     filteredData[category] = filtered;
  //   });

  //   // Sort dates chronologically
  //   // const days = Array.from(allDatesSet).sort((a, b) => {
  //   //   const parseDate = (str: string) => new Date(Date.parse(str + ' 2025')); // crude fallback to year
  //   //   return parseDate(a).getTime() - parseDate(b).getTime();
  //   // });

  //   const days = Array.from(allDatesSet).sort((a, b) => {
  //     const parse = (str: string) => new Date(Date.parse(str + ' ' + now.getFullYear()));
  //     return parse(a).getTime() - parse(b).getTime();
  //   });

  //   // Helper: Count incidents per day per category
  //   // const countIncidentsByDay = (incidents: any[]): number[] => {
  //   //   const counts: Record<string, number> = {};
  //   //   incidents.forEach(incident => {
  //   //     const date = new Date(incident.incidentDate);
  //   //     const formattedDate = date.toLocaleDateString('en-GB', {
  //   //       day: '2-digit',
  //   //       month: 'short',
  //   //     });
  //   //     counts[formattedDate] = (counts[formattedDate] || 0) + 1;
  //   //   });
  //   //   return days.map(day => counts[day] || 0);
  //   // };
  //   const countIncidentsByDay = (incidents: any[]): number[] => {
  //     const counts: Record<string, number> = {};
  //     incidents.forEach(incident => {
  //       const formatted = formatDate(new Date(incident.incidentDate));
  //       counts[formatted] = (counts[formatted] || 0) + 1;
  //     });
  //     return days.map(day => counts[day] || 0);
  //   };

  //   return {
  //     title: {
  //       text: 'Incident Trends by Category',
  //       left: 'center',
  //       top: 10,
  //     },
  //     tooltip: {
  //       trigger: 'axis',
  //       axisPointer: { type: 'shadow' },
  //       formatter: (params: any) => {
  //         const items = Array.isArray(params) ? params : [params];
  //         const total = items.reduce((sum, item) => sum + Number(item.value), 0);
  //         return items
  //           .map(
  //             item =>
  //               `${item.seriesName}: ${item.value} (${(
  //                 (Number(item.value) / total) *
  //                 100
  //               ).toFixed(1)}%)`
  //           )
  //           .join('<br>');
  //       },
  //     },
  //     legend: {
  //       top: 40,
  //       data: categories,
  //     },
  //     grid: {
  //       left: '3%',
  //       right: '4%',
  //       bottom: '3%',
  //       containLabel: true,
  //     },
  //     xAxis: [
  //       {
  //         type: 'category',
  //         data: days,
  //       },
  //     ],
  //     yAxis: [
  //       {
  //         type: 'value',
  //         axisLabel: {
  //           formatter: '{value}',
  //         },
  //         minInterval: 1,
  //       },
  //     ],
  //     series: categories.map(category => ({
  //       name: category,
  //       type: 'bar',
  //       stack: 'total',
  //       emphasis: { focus: 'series' },
  //       data: countIncidentsByDay(data[category] || []),
  //     })),
  //     toolbox: {
  //       feature: {
  //         saveAsImage: {},
  //       },
  //     },
  //   };
  // }

  generateChartOption(data: any, range: '1d' | '1w' | '1m' | '1y'): any {
    if (!data || typeof data !== 'object') return;
    const categories = Object.keys(data);
    const now = new Date();
    let startDate = new Date(now);

    switch (range) {
      case '1d':
        startDate.setDate(now.getDate() - 1);
        break;
      case '1w':
        startDate.setDate(now.getDate() - 7);
        break;
      case '1m':
        startDate.setMonth(now.getMonth() - 1);
        break;
      case '1y':
        startDate.setFullYear(now.getFullYear() - 1);
        break;
    }

    const formatDate = (date: Date): string =>
      date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });

    const allDatesSet = new Set<string>();
    const filteredData: Record<string, any[]> = {};

    categories.forEach((category) => {
      const filtered = (data[category] || []).filter((incident: any) => {
        const incidentDate = new Date(incident.incidentDate);
        return incidentDate >= startDate && incidentDate <= now;
      });

      filtered.forEach((incident: any) => {
        allDatesSet.add(formatDate(new Date(incident.incidentDate)));
      });

      filteredData[category] = filtered;
    });

    const days = Array.from(allDatesSet).sort((a, b) => {
      const parse = (str: string) =>
        new Date(Date.parse(str + ' ' + now.getFullYear()));
      return parse(a).getTime() - parse(b).getTime();
    });

    const countIncidentsByDay = (incidents: any[]): number[] => {
      const counts: Record<string, number> = {};
      incidents.forEach((incident) => {
        const formatted = formatDate(new Date(incident.incidentDate));
        counts[formatted] = (counts[formatted] || 0) + 1;
      });
      return days.map((day) => counts[day] || 0);
    };

    return {
      title: {
        text: 'Incident Trends by Category',
        left: 'center',
        top: 10,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        formatter: (params: any) => {
          const items = Array.isArray(params) ? params : [params];
          const total = items.reduce(
            (sum, item) => sum + Number(item.value),
            0
          );
          return items
            .map(
              (item) =>
                `${item.seriesName}: ${item.value} (${(
                  (Number(item.value) / total) *
                  100
                ).toFixed(1)}%)`
            )
            .join('<br>');
        },
      },
      legend: {
        top: 40,
        data: categories,
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          data: days,
        },
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: '{value}',
          },
          minInterval: 1,
        },
      ],
      series: categories.map((category) => ({
        name: category,
        type: 'bar',
        stack: 'total',
        emphasis: { focus: 'series' },
        data: countIncidentsByDay(filteredData[category] || []),
      })),
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
    };
  }

  generateRiskTrendChart() {
    // Step 1: Get the latest score for each date
    const latestScoresByDate: {
      [date: string]: { timestamp: string; score: number };
    } = {};

    for (const [timestamp, score] of Object.entries(
      this.OverallRiskScoresByDateRange
    )) {
      const date = new Date(timestamp).toLocaleDateString('en-US'); // e.g., "6/3/2025"

      if (
        !latestScoresByDate[date] ||
        new Date(timestamp).getTime() >
        new Date(latestScoresByDate[date].timestamp).getTime()
      ) {
        latestScoresByDate[date] = {
          timestamp,
          score: score as number,
        };
      }
    }

    // Step 2: Sort dates
    const dates = Object.keys(latestScoresByDate).sort(
      (a, b) => new Date(a).getTime() - new Date(b).getTime()
    );

    // Step 3: Extract scores
    const scores = dates.map(
      (date) => +latestScoresByDate[date].score.toFixed(2)
    );

    // Optional: Determine max score for Y-axis
    const maxScore = Math.ceil(Math.max(...scores) / 100) * 100;

    // Step 4: Chart config
    this.RiskTrendData = {
      title: {
        text: 'Risk Trend Over Time',
        left: 'center',
        top: '10',
      },
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: ['Risk Score'],
        top: 35,
        left: 'center',
      },
      xAxis: {
        type: 'category',
        data: dates,
        boundaryGap: false,
      },
      yAxis: {
        type: 'value',
        min: 0,
        max: maxScore,
        axisLabel: {
          formatter: '{value}',
        },
      },
      series: [
        {
          name: 'Risk Score',
          type: 'line',
          smooth: true,
          data: scores,
          symbol: 'circle',
          symbolSize: 8,
          lineStyle: {
            color: '#f44336',
            width: 3,
          },
          itemStyle: {
            color: '#f44336',
          },
          areaStyle: {
            color: 'rgba(244, 67, 54, 0.2)',
          },
        },
      ],
    };
  }

  overallScore = 0;
  mapOptions: MapOptions;
  mapLayers: Layer[] = [];
  categories: IRiskCategoryTrend[] = [];
  dailyBreakdown: any;
  incidentCounts: any;
  topContributors: any[] = [];
  totalPersonnel = 0;

  riskStatuses = [
    { label: 'Critical', count: 0 },
    { label: 'Unverified', count: 0 },
    { label: 'Unmonitored', count: 0 },
    { label: 'Faulty', count: 0 },
  ];

  assets = [
    {
      name: 'Server Room A',
      location: '40.7128, -74.0060',
      lastIncident: new Date('2023-09-15T16:00:00'),
      riskScore: 90,
    },
    {
      name: 'Main Generator',
      location: '40.7142, -74.0064',
      lastIncident: new Date('2023-09-15T14:45:00'),
      riskScore: 80,
    },
  ];
  incidents: IIncident[] = [];
  /* incidents = [
    {
      category: 'Security',
      score: 80,
      total: 1,
      critical: 0,
      quickest: 0,
      longest: 0,
      weakestHour: '12AM',
      strongestOccupancy: '12AM',
      chartData: {
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            smooth: true
          }
        ]
      }
    },
    {
      category: 'Safety',
      score: 50,
      total: 0,
      critical: 0,
      quickest: 0,
      longest: 0,
      weakestHour: '12AM',
      strongestOccupancy: '12AM',
      chartData: <EChartsOption>{
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line',
            smooth: true
          }
        ]
      }
    },
    // Add other categories similarly
  ]; */

  /* chartOptions: ChartConfiguration['options'] = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        min: 0,
        max: 1,
        ticks: {
          stepSize: 0.2
        }
      }
    },
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true }
    }
  }; */

  constructor(
    private riskService: RiskService,
    private breakpointObserver: BreakpointObserver,
    private screen: AumyeResponsiveScreenService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  ScreenType = ScreenType;
  ngOnInit() {
    // this.loadOverallScore();
    // this.initMap();
    // this.loadCategoryMetrics();
    // this.loadDailyBreakdown();
    // this.loadIncidentCounts();
    // this.loadTopContributors();
    // this.loadPersonnel();
    // this.configureResponsiveGrid();
    // this.updateMapData();
    // console.log(this.categoryRiskTrends)
    // console.log(this.overallRiskScore)
    // console.log(this.overallRiskTrend)
    // console.log(this.overallRiskChangePercentage)
  }

  ngAfterViewInit() {
    const circle = document.querySelector(
      '.progress-ring__circle'
    ) as SVGCircleElement;
    if (circle) {
      const radius = circle.r.baseVal.value;
      const circumference = 2 * Math.PI * radius;

      circle.style.strokeDasharray = `${circumference}`;
      circle.style.strokeDashoffset = `${circumference}`;

      const percent = Math.min(this.overallScore / 1000, 1);
      const offset = circumference - percent * circumference;

      setTimeout(() => {
        circle.style.strokeDashoffset = `${offset}`;
      }, 100);
    }
  }
  getRiskColor(): 'warn' | 'accent' | 'primary' {
    if (this.overallScore >= 800) return 'warn'; // High Risk
    else if (this.overallScore >= 400) return 'accent'; // Medium Risk
    else return 'primary'; // Low Risk
  }

  getOverallScoreColor(score: number): string {
    if (score >= 800) return '#f44336'; // Red - High Risk
    if (score >= 500) return '#ff9800'; // Orange - Medium Risk
    if (score >= 200) return '#ffc107'; // Yellow - Moderate Risk
    return '#4caf50'; // Green - Low Risk
  }

  updateRiskScoreProgress() {
    this.overallScore = 300;
    // const circle = document.querySelector('.progress-ring__circle') as SVGCircleElement;
    // if (circle) {
    //   const radius = circle.r.baseVal.value;
    //   const circumference = 2 * Math.PI * radius;

    //   circle.style.strokeDasharray = `${circumference}`;
    //   circle.style.strokeDashoffset = `${circumference}`;

    //   const percent = Math.min(this.overallScore / 1000, 1);
    //   const offset = circumference - percent * circumference;

    //   setTimeout(() => {
    //     circle.style.strokeDashoffset = `${offset}`;
    //   }, 100);
    // }
  }

  // createLineChartOptions(
  //   title: string,
  //   xData: string[],
  //   yData: number[],
  //   color: string = '#f44336',
  //   label: string = 'Risk Score'
  // ): EChartsOption {
  //   return {
  //     title: {
  //       text: title,
  //       left: 'center',
  //       top: '10'
  //     },
  //     tooltip: {
  //       trigger: 'axis'
  //     },
  //     legend: {
  //       data: [label],
  //       top: 35,
  //       left: 'center'
  //     },
  //     xAxis: {
  //       type: 'category',
  //       data: xData,
  //       boundaryGap: false
  //     },
  //     yAxis: {
  //       type: 'value',
  //       min: 0,
  //       max: 100,
  //       axisLabel: {
  //         formatter: '{value} %'
  //       }
  //     },
  //     series: [
  //       {
  //         name: label,
  //         type: 'line',
  //         smooth: true,
  //         data: yData,
  //         symbol: 'circle',
  //         symbolSize: 8,
  //         lineStyle: {
  //           color: color,
  //           width: 3
  //         },
  //         itemStyle: {
  //           color: color
  //         },
  //         // areaStyle: {
  //         //   color: color.replace('1)', '0.2)').replace('rgb', 'rgba')
  //         // }
  //       }
  //     ]
  //   };
  // }

  // updateMapData() {
  //   this.RiskTrendData = this.createLineChartOptions(
  //     'Risk Trend Over Time',
  //     ['9/1/2023', '9/2/2023', '9/3/2023', '9/4/2023', '9/5/2023'],
  //     [40, 60, 30, 70, 50],
  //     '#f44336'
  //   );

  //   this.CategoricalBreakdown = this.createLineChartOptions(
  //     'Category Breakdown',
  //     ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  //     [820, 932, 901, 934, 1290, 1330, 1320],
  //     '#3b82f6',
  //     'Category Score'
  //   );
  // }

  // processIncidentData() {
  //   this.incidents = [];

  //   for (const category in this.categorizedIncidents) {
  //     const items = this.categorizedIncidents[category];

  //     if (!items.length) continue;

  //     const total = items.length;
  //     const critical = items.filter(
  //       (i: { previousCriticality: number }) => i.previousCriticality >= 100
  //     ).length;

  //     const quickest = Math.min(
  //       ...items.map(
  //         (i: { quickestResolutionTime: any }) => i.quickestResolutionTime
  //       )
  //     );
  //     const longest = Math.max(
  //       ...items.map(
  //         (i: { quickestResolutionTime: any }) => i.quickestResolutionTime
  //       )
  //     );
  //     const weakestHour = this.getMostCommonHour(
  //       items.map((i: { weakestHour: any }) => i.weakestHour)
  //     );
  //     const strongestHour = this.getMostCommonHour(
  //       items.map((i: { strongestHour: any }) => i.strongestHour)
  //     );

  //     this.incidents.push({
  //       category,
  //       total,
  //       critical,
  //       quickest: this.formatHighestUnitFromMinutes(
  //         Number(quickest.toFixed(2))
  //       ),
  //       longest: this.formatHighestUnitFromMinutes(Number(longest.toFixed(2))),
  //       weakestHour,
  //       strongestOccupancy: strongestHour,
  //       score: this.calculateScore(items),
  //       // chartData: items.map((i: { riskTrendPercentage: any; }) => i.riskTrendPercentage)
  //       chartData: <EChartsOption>{
  //         xAxis: {
  //           type: 'category',
  //           data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  //         },
  //         yAxis: {
  //           type: 'value',
  //         },
  //         series: [
  //           {
  //             data: [820, 932, 901, 934, 1290, 1330, 1320],
  //             type: 'line',
  //             smooth: true,
  //           },
  //         ],
  //       },
  //     });
  //   }
  // }

  getMostCommonHour(hours: number[]) {
    const freqMap: any = {};
    hours.forEach((h) => (freqMap[h] = (freqMap[h] || 0) + 1));
    // return Object.entries(freqMap).sort((a, b) => b[1] - a[1])[0][0];
    const entries: [string, number][] = Object.entries(freqMap) as [
      string,
      number
    ][];
    entries.sort((a, b) => b[1] - a[1]);
    return entries[0][0];
  }

  calculateScore(items: any[]): number {
    const total = items.reduce((sum, i) => sum + i.riskScore, 0);
    return Math.round(total / items.length);
  }

  prepareCategories() {
    if (
      !this.categorizedIncidents ||
      typeof this.categorizedIncidents !== 'object'
    )
      return;
    this.categories = [];

    for (const [key, incidents] of Object.entries(this.categorizedIncidents)) {
      const incidentsArray = incidents as IcategorizedIncidents[];

      const incidentsCount = incidentsArray.length;

      let trend = 0;
      if (incidentsCount > 0) {
        trend =
          incidentsArray.reduce(
            (sum, inc: any) => sum + inc.riskTrendPercentage,
            0
          ) / incidentsCount;
      }

      let trendDirection: 'up' | 'down' | 'neutral' = 'neutral';
      if (trend > 0) trendDirection = 'up';
      else if (trend < 0) trendDirection = 'down';

      this.categories.push({
        name: key,
        incidentsCount,
        trend: Math.abs(Math.round(trend)),
        trendDirection,
      });
    }
  }

  populateCategoricalBreakdown(data: Record<string, any[]>) {
    const categories: string[] = [];
    const scores: number[] = [];

    for (const [category, incidents] of Object.entries(data)) {
      categories.push(category);

      if (incidents.length === 0) {
        scores.push(0);
        continue;
      }

      const totalScore = incidents.reduce(
        (sum, incident) => sum + (incident.riskScore || 0),
        0
      );
      const avgScore = totalScore / incidents.length;
      scores.push(+avgScore.toFixed(2));
    }

    this.CategoricalBreakdown = {
      title: {
        text: 'Average Risk Score per Category',
        left: 'center',
      },
      tooltip: {
        trigger: 'axis',
      },
      xAxis: {
        type: 'category',
        data: categories,
      },
      yAxis: {
        type: 'value',
        min: 0,
      },
      series: [
        {
          data: scores,
          type: 'bar',
          itemStyle: {
            color: '#3b82f6',
          },
        },
      ],
    };
  }

  updateCategoricalBreakdownFromIncidents(data: any) {
    if (!data || typeof data !== 'object') return;
    this.incidents = [];
    for (const [category, incidentList] of Object.entries(data)) {
      if (!Array.isArray(incidentList) || incidentList.length === 0) continue;
      
      const total = incidentList.length;
      const critical = incidentList.filter(
        (i: any) => i.previousCriticality >= 80
      ).length;
      const quickest = Math.min(
        ...incidentList.map((i: any) => i.quickestResolutionTime)
      );
      const longest = Math.max(
        ...incidentList.map((i: any) => i.quickestResolutionTime)
      );
      
      // this.categorizedRiskScore?.[category] ?? 0
      const avgScore = Math.round(
        incidentList.reduce((acc: any, curr: any) => acc + curr.riskScore, 0) /
        total
      );

      const nameCounts: Record<string, number> = {};
      for (const inc of incidentList) {
        const name = inc.incidentName || 'Unknown';
        nameCounts[name] = (nameCounts[name] || 0) + 1;
      }

      // const chartData: EChartsOption = {
      //   title: {
      //     text: `${category} Incident Types`,
      //     left: 'center',
      //     top: 10
      //   },
      //   tooltip: {
      //     trigger: 'axis',
      //     axisPointer: { type: 'shadow' }
      //   },
      //   xAxis: {
      //     type: 'category', // ✅ literal type
      //     data: Object.keys(nameCounts)
      //   },
      //   yAxis: {
      //     type: 'value' // ✅ literal type
      //   },
      //   series: [
      //     {
      //       name: 'Count',
      //       type: 'bar', // ✅ literal type
      //       data: Object.values(nameCounts),
      //       barWidth: '50%',
      //       label: {
      //         show: true,
      //         position: 'top'
      //       },
      //       itemStyle: {
      //         color: '#3b82f6'
      //       }
      //     }
      //   ]
      // };

      const chartData: EChartsOption = {
        title: {
          text: 'Average Risk Score per Category',
          left: 'center',
        },
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          type: 'category',
          data: Object.keys(nameCounts),
        },
        yAxis: {
          type: 'value',
          min: 0,
        },
        series: [
          {
            data: Object.values(nameCounts),
            type: 'bar',
            itemStyle: {
              color: '#3b82f6',
            },
          },
        ],
      };

      // const chartData: EChartsOption = {
      //   title: { text: `Incident Risk Scores`, left: 'center', top: '10' },
      //   tooltip: { trigger: 'axis' },
      //   xAxis: {
      //     type: 'category',
      //     data: incidentList.map((inc: any, i: number) => `#${i + 1}`),
      //     name: 'Incident'
      //   },
      //   yAxis: {
      //     type: 'value',
      //     name: 'Risk Score',
      //     min: 0
      //   },
      //   series: [
      //     {
      //       name: 'Risk Score',
      //       data: incidentList.map((inc: any) => inc.riskScore),
      //       type: 'bar',
      //       itemStyle: {
      //         color: '#3b82f6'
      //       },
      //       label: {
      //         show: true,
      //         position: 'top'
      //       }
      //     }
      //   ]
      // };

      this.incidents.push({
        category,
        total,
        critical,
        quickest: this.formatHighestUnitFromMinutes(
          Number(quickest.toFixed(2))
        ),
        longest: this.formatHighestUnitFromMinutes(Number(longest.toFixed(2))),
        score: this.categorizedRiskScore?.[category] ?? 0,
        weakestHour: this.formatHour(incidentList[0].weakestHour),
        strongestOccupancy: this.formatHour(incidentList[0].strongestHour),
        chartData,
      });
    }
  }

  // generatePerCategoryBarCharts(data: any) {
  //   this.categoryCharts = {};

  //   for (const [category, incidents] of Object.entries(data)) {
  //     if (!Array.isArray(incidents) || incidents.length === 0) continue;

  //     const nameCounts = new Map<string, number>();

  //     for (const incident of incidents) {
  //       const name = incident.incidentName || 'Unknown';
  //       nameCounts.set(name, (nameCounts.get(name) || 0) + 1);
  //     }

  //     const names = Array.from(nameCounts.keys());
  //     const counts = Array.from(nameCounts.values());

  //     this.categoryCharts[category] = {
  //       title: {
  //         text: `${category} Incidents`,
  //         left: 'center'
  //       },
  //       tooltip: {
  //         trigger: 'axis',
  //         axisPointer: { type: 'shadow' }
  //       },
  //       xAxis: {
  //         type: 'category',
  //         data: names,
  //         axisLabel: { rotate: 45 }
  //       },
  //       yAxis: {
  //         type: 'value',
  //         name: 'Count'
  //       },
  //       series: [
  //         {
  //           name: 'Count',
  //           type: 'bar',
  //           data: counts,
  //           itemStyle: {
  //             color: '#2196f3'
  //           },
  //           label: {
  //             show: true,
  //             position: 'top'
  //           }
  //         }
  //       ]
  //     };
  //   }
  // }

  // updatePerformanceIndicators() {
  //   if (!this.categorizedIncidents || !this.categorizedIncidents['Safety']?.length) {
  //     return;
  //   }

  //   const safetyIncidents = this.categorizedIncidents['Safety'];

  //   // Quickest and Longest response times
  //   this.quickestResponseTime = Math.min(...safetyIncidents.map((i: { quickestResolutionTime: any; }) => i.quickestResolutionTime));
  //   this.longestResponseTime = Math.max(...safetyIncidents.map((i: { quickestResolutionTime: any; }) => i.quickestResolutionTime));

  //   // For hottest, strongest, weakest hours, take the mode or first (assuming consistency)
  //   // You could also calculate incident counts per hour for hottestHourIncidentCount
  //   const hottestHour = safetyIncidents[0].hottestHour;
  //   const strongestHour = safetyIncidents[0].strongestHour;
  //   const weakestHour = safetyIncidents[0].weakestHour;

  //   this.hottestHour = hottestHour;
  //   this.strongestHour = strongestHour;
  //   this.weakestHour = weakestHour;

  //   // Count incidents during hottest hour
  //   this.hottestHourIncidentCount = safetyIncidents.filter((i: { hottestHour: any; }) => i.hottestHour === hottestHour).length;

  //   // Update performanceIndicators array values
  //   this.performanceIndicators = [
  //     { label: 'Quickest Response', value: `${this.quickestResponseTime.toFixed(2)}m` },
  //     { label: 'Longest Response', value: `${this.longestResponseTime.toFixed(2)}m` },
  //     {
  //       label: 'Hottest Hour',
  //       value: this.formatHour(this.hottestHour),
  //       subtext: `${this.hottestHourIncidentCount} incidents`
  //     },
  //     { label: 'Strongest Hour', value: this.formatHour(this.strongestHour) },
  //     { label: 'Weakest Hour', value: this.formatHour(this.weakestHour) },
  //     { label: 'Strongest Occupancy', value: this.formatHour(this.strongestHour), subtext: '→ 0%' }
  //   ];
  // }

  updatePerformanceIndicators() {
    if (!this.categorizedIncidents) {
      return;
    }

    const allIncidents = Object.values(this.categorizedIncidents).flat() as {
      quickestResolutionTime: number;
      hottestHour: number;
      weakestHour: number;
      strongestHour: number;
    }[];

    if (!allIncidents.length) {
      return;
    }

    this.quickestResponseTime = Math.min(
      ...allIncidents.map((i) => i.quickestResolutionTime)
    );
    this.longestResponseTime = Math.max(
      ...allIncidents.map((i) => i.quickestResolutionTime)
    );

    const getMode = (arr: number[]) =>
      arr
        .sort(
          (a, b) =>
            arr.filter((v) => v === a).length -
            arr.filter((v) => v === b).length
        )
        .pop();

    const hottestHours = allIncidents.map((i) => i.hottestHour);
    const strongestHours = allIncidents.map((i) => i.strongestHour);
    const weakestHours = allIncidents.map((i) => i.weakestHour);

    this.hottestHour = getMode(hottestHours);
    this.strongestHour = getMode(strongestHours);
    this.weakestHour = getMode(weakestHours);

    this.hottestHourIncidentCount = allIncidents.filter(
      (i) => i.hottestHour === this.hottestHour
    ).length;

    this.performanceIndicators = [
      // { label: 'Quickest Response', value: `${this.quickestResponseTime.toFixed(2)}m` },
      // { label: 'Longest Response', value: `${this.longestResponseTime.toFixed(2)}m` },
      {
        label: 'Quickest Response',
        value: `${this.formatHighestUnitFromMinutes(
          this.quickestResponseTime
        )}`,
      },
      {
        label: 'Longest Response',
        value: `${this.formatHighestUnitFromMinutes(this.longestResponseTime)}`,
      },
      {
        label: 'Hottest Hour',
        value: this.formatHour(this.hottestHour),
        subtext: `${this.hottestHourIncidentCount} incidents`,
      },
      { label: 'Strongest Hour', value: this.formatHour(this.strongestHour) },
      { label: 'Weakest Hour', value: this.formatHour(this.weakestHour) },
      {
        label: 'Strongest Occupancy',
        value: this.formatHour(this.strongestHour),
        subtext: '→ 0%',
      },
    ];
  }

  getTooltip(indicator: {
    label: string;
    value: string;
    subtext?: string;
  }): string {
    let tooltip: string;
    switch (indicator.label) {
      case 'Quickest Response':
        tooltip =
          'Quickest Response: Quickest Time taken to move Incident raised to first status change';
        break;

      case 'Longest Response':
        tooltip =
          'Longest Response: Highest time taken to move incident raised to first status change';
        break;

      case 'Hottest Hour':
        tooltip = 'Hottest Hour: Hour with the most raised incidents';
        break;

      case 'Strongest Hour':
        tooltip =
          'Strongest Hour: Hour that witnessed highest resolution rate(moved to complete, closed or rejected) with comparatively lower personnel availability';
        break;

      case 'Weakest Hour':
        tooltip =
          'Weakest Hour: Hour that witnessed lowest resolution rate(moved to complete, closed or rejected) with comparatively higher personnel availability';
        break;

      case 'Strongest Occupancy':
        tooltip =
          'Strongest Occupancy: Hour that had the most personnel availability';
        break;

      default:
        break;
    }
    // let tooltip = `${indicator.label}: ${indicator.value}`;
    // if (indicator.subtext) {
    //   tooltip += ` (${indicator.subtext})`;
    // }
    return tooltip;
  }

  formatHighestUnitFromMinutes(minutes: number) {
    const totalSeconds = Math.floor(minutes * 60);

    const days = Math.floor(totalSeconds / (24 * 3600));
    if (days > 0) return `${days}d`;

    const hours = Math.floor(totalSeconds / 3600);
    if (hours > 0) return `${hours}h`;

    const mins = Math.floor(totalSeconds / 60);
    if (mins > 0) return `${mins}m`;

    const secs = totalSeconds;
    return `${secs}s`;
  }

  getClass(label: string): string {
    switch (label) {
      case 'Quickest Response':
        return 'success';
      case 'Longest Response':
        return 'danger';
      case 'Hottest Hour':
        return 'warning';
      case 'Strongest Hour':
        return 'info';
      case 'Weakest Hour':
        return 'purple';
      case 'Strongest Occupancy':
        return 'info';
      default:
        return '';
    }
  }

  getIcon(label: string): string {
    switch (label) {
      case 'Quickest Response':
        return 'emoji_events';
      case 'Longest Response':
        return 'schedule';
      case 'Hottest Hour':
        return 'whatshot';
      case 'Strongest Hour':
        return 'insights';
      case 'Weakest Hour':
        return 'info';
      case 'Strongest Occupancy':
        return 'groups';
      default:
        return 'info';
    }
  }

  // private formatHour(hour24: number): string {
  //   const suffix = hour24 >= 12 ? 'PM' : 'AM';
  //   const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
  //   return `${hour12}${suffix}`;
  // }

  private formatHour(hour24: number): string {
    if (isNaN(hour24) || hour24 < 0 || hour24 > 23) return 'N/A';
    const suffix = hour24 >= 12 ? 'PM' : 'AM';
    const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
    return `${hour12}${suffix}`;
  }

  // loadOverallScore() {
  //   this.riskService.getOverallScore().subscribe(score => this.overallScore = score);
  // }

  initMap() {
    this.mapOptions = {
      center: latLng(0, 0),
      zoom: 2,
      layers: [
        tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 18,
        }),
      ],
    };

    this.riskService.getHotspots().subscribe((points) => {
      this.mapLayers = points.map((p) =>
        circleMarker([p.lat, p.lng], {
          radius: Math.max(5, p.count / 5),
        }).bindPopup(`${p.location}: ${p.count} incidents`)
      );
    });
  }

  configureResponsiveGrid() {
    this.breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.Tablet])
      .subscribe((result) => {
        if (result.matches) {
          this.gridCols = 1;
          this.catCols = 1;
        } else {
          this.gridCols = 4;
          this.catCols = 3;
        }
      });
  }
}
